import { HttpContextToken } from '@angular/common/http';

/**
 * Per-call opt-out from payload encryption.
 *
 * Every generated `fn/*` helper already accepts a trailing `context?: HttpContext`
 * and threads it to `http.request()`, so a single call can be excluded without
 * touching the generated client (and without the opt-out being lost on the next
 * `npm run codegen`):
 *
 * ```ts
 * this.clientController.getClientDetails(
 *   { body },
 *   new HttpContext().set(SKIP_CRYPTO, true)
 * );
 * ```
 *
 * Prefer `PLAINTEXT_*` in `plaintext-paths.ts` when the endpoint is plaintext on
 * the backend — this token is for one-off client-side exceptions only.
 */
export const SKIP_CRYPTO = new HttpContextToken<boolean>(() => false);
